import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-tactical-dark selection:bg-tactical-accent/30 selection:text-tactical-accent" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Hook data-id="element-3" />
        <Problem data-id="element-4" />
        <FailedAttempts data-id="element-5" />
        <Mechanism data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <ForWhom data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <Offer data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}